




























































import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'

@Component
export default class DeliveryConfirmPage extends Vue {
  status: 'success' | 'failed' | null = null

  processing = false

  loading = false

  payments: any[] = []

  receivedId = null

  mounted() {
    this.loading = true
    axios.get(`payments/${this.$route.params.certification}/payments`).then(({ data }) => {
      this.payments = this.filterValidPayments(data)
      this.loading = false
    })
  }

  filterValidPayments(payments: any[]) {
    return payments.filter((payment) => {
      if (!payment.isConfirmed) {
        return false
      }

      if (payment.delivered) {
        return false
      }

      if (!payment.shipped) {
        return false
      }
      return true
    })
  }

  displayType(payment: any) {
    let text = null
    switch (payment.paymentType) {
      case 'certificate':
        text = 'E-Certificate'
        break
      case 'hard-copies':
        text = '2 x Hard Copies'
        break
      case 'embossed':
        text = 'Professional Embossed Copy'
        break
    }
    return `${text} - paid on ${new Date(payment.paymentDate).toLocaleString()}`
  }

  retry() {
    this.status = null
  }

  async markAsDelivered() {
    if (!this.receivedId) {
      return
    }
    this.status = null
    this.processing = true

    try {
      await axios.post(`payments/${this.receivedId}/confirm-delivery`)
      this.status = 'success'
    } catch (error) {
      this.status = 'failed'
    } finally {
      this.processing = false
    }
  }
}
